import { AdminWorkspace } from "../components/AdminWorkspace/AdminWorkspace";
import { UserWorkspace } from "../components/UserWorkspace/UserWorkspace";
import { useUserRoles } from "../hooks/useUserRoles";
import "./Home.scss";

export const Home = () => {
  const { isAdmin } = useUserRoles();

  return (
    <div className="home-page">
      <div className="home-container">
        {isAdmin ? <AdminWorkspace /> : <UserWorkspace />}
      </div>
    </div>
  );
};
